import { combineReducers, configureStore } from "@reduxjs/toolkit";
import reportSlice from "./slices/reportSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import utilSlice from "./slices/utilSlice";
import userPrivilegesReducer from "./slices/userPrivilegesSlice";


// Define slices
const reportReducer = reportSlice;
const utilsReducer = utilSlice;


// Combine reducers
const rootReducer = combineReducers({
  report: reportReducer,
  utils: utilsReducer,
  userPrivileges: userPrivilegesReducer,
});
// Create persistConfig
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["userPrivileges"]
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the Redux store
const store = configureStore({
  reducer: persistedReducer,
});

// Create the persistor
const persistor = persistStore(store);

export { store, persistor };